import { Button } from '@givebutter/primitives/button';
import { useToast } from '@givebutter/primitives/toast';
import { faCheck, faLinkSimple } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCopy } from 'components/snippet';

const CopyTaskLinkButton = () => {
    const { success } = useToast();
    const { didCopy, onClickCopy } = useCopy({
        onCopy: () => success('Task copied to clipboard'),
    });

    return (
        <Button
            variant="outline"
            color="neutral"
            shape={'square'}
            size="sm"
            className="!w-8"
            onClick={e => {
                onClickCopy(e, window.location.toString());
            }}
            aria-label="Copy task link"
        >
            <FontAwesomeIcon icon={didCopy ? faCheck : faLinkSimple} />
        </Button>
    );
};

export { CopyTaskLinkButton };
